import { render, staticRenderFns } from "./SearchReadOnly.vue?vue&type=template&id=53d5714b"
import script from "./SearchReadOnly.vue?vue&type=script&lang=js"
export * from "./SearchReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports